import React from 'react';
import { Button, Stack } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Form } from 'mobx-react-form';
import { DropResult } from 'react-beautiful-dnd';

import SaleTable from './SalesTable';
import SaleCondition from './SaleCondition';

type SalesHistoryProps = {
  form: Form;
};

const SalesHistory = observer(({ form }: SalesHistoryProps) => {
  const salesHistoryField = form.$('propertyHistory.salesHistory');
  const salesHistory: any = salesHistoryField.values() || [];

  const addSale = () => {
    /*
     * this is correct way for adding new object to array
     * https://github.com/foxhound87/mobx-react-form/issues/451#issuecomment-433649652
     */
    salesHistoryField.add([
      {
        uniqueSaleId: null,
        date: null,
        price: null,
        seller: null,
        saleCondition: null,
      },
    ]);
  };

  const moveSale = ({ source, destination }: DropResult) => {
    if (!destination) {
      return;
    }

    const newSalesHistory = [...salesHistory];
    const [movedItem] = newSalesHistory.splice(source.index, 1);
    newSalesHistory.splice(destination.index, 0, movedItem);

    salesHistoryField.set(newSalesHistory);
  };

  const removeSale = (index: number) => {
    const lastIndex = salesHistory.length - 1;

    const newSalesHistory = salesHistory.filter((_: Record<string, any>, i: number) => i !== index);

    // this is correct
    salesHistoryField.set(newSalesHistory);
    salesHistoryField.del(lastIndex);
  };

  return (
    <>
      <Stack spacing={1}>
        <Button onClick={addSale} variant="contained" sx={{ alignSelf: 'start' }}>
          ADD SALE
        </Button>
        <SaleTable moveSale={moveSale} removeSale={removeSale} salesHistory={salesHistory} form={form} />
      </Stack>
      {salesHistory
        // There is a sorting in Webapp, but it's not working. Not sure if we need it here
        // .slice()
        // .sort((first: { date: string }, second: { date: string }) => Date.parse(second.date) - Date.parse(first.date))
        .map((item: any, index: any) => (
          <SaleCondition form={form} salesHistoryItem={item} key={`saleCondition-${index}`} index={index} />
        ))}
    </>
  );
});

export default SalesHistory;
